export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function generateThousandSeparator(string) {
    return string?.replace(/\B(?=(\d{3})+(?!\d))/g, '.') ?? '';
}

export function toCamelCase(str) {
    // Convert the string to lowercase and then split it by spaces, hyphens, or underscores
    return str.toLowerCase().split(/[\s-_]+/)
        .map((word, index) => {
            // Capitalize the first letter of each word except the first one
            if (index === 0) {
                return word;
            }
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(''); // Join the words back together without spaces
}

